import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  hotelAmenities: {
    padding: "24px 16px",
    borderRadius: "8px",
    backgroundColor: theme.palette.entityColors.entityColorBackground1,
  },
  hotelAmenitiesTitle: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "16px",
  },
  hotelAmenitiesListsWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  hotelAmenitiesList: {
    listStyle: "none",
  },
  hotelAmenitiesListItem: {
    lineHeight: 2.2,
    fontSize: "14px",
  },
  hotelAmenitiesViewMoreWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  hotelAmenitiesViewMore: {
    borderRadius: "8px",
    border: `1px solid ${theme.palette.entityColors.entityColorBorder}`,
    padding: "16px",
    marginLeft: "auto",
    marginTop: "32px",
    backgroundColor: theme.palette.entityColors.entityColorBackground1,
    color: '#344054',
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export default useStyles;
